import './App.css';
import Dashboard from './components/dashboard';
import CustomAppBar from './components/MyAppBar';

function App() {
  return (
    <div className="App">
      <div className="content">
        <CustomAppBar />
        <Dashboard />
      </div>
    </div>
  );
}

export default App;
